import { Navigate, Route, Routes } from 'react-router-dom';
import { PlatformRoute, ProtectedRoute } from '../auth/ProtectedRoute';
import { AdminLayout } from '../layouts/AdminLayout';
import { useAuth } from '../auth/AuthContext';
import { LoginPage } from '../pages/auth/LoginPage';
import { RegisterPage } from '../pages/auth/RegisterPage';
import { ResetPasswordPage } from '../pages/auth/ResetPasswordPage';
import { DashboardPage } from '../pages/DashboardPage';
import { UsersPage } from '../pages/maintenance/UsersPage';
import { CustomersPage } from '../pages/maintenance/CustomersPage';
import { SettingPage } from '../pages/settings/SettingPage';
import { AppearancePage } from '../pages/settings/AppearancePage';
import { AboutUsPage } from '../pages/settings/AboutUsPage';
import { WhatsAppPage } from '../pages/settings/WhatsAppPage';
import { BookingsPage } from '../pages/booking/BookingsPage';
import { ServicesPage } from '../pages/booking/ServicesPage';
import { ServiceCategoriesPage } from '../pages/booking/ServiceCategoriesPage';
import { CustomFormsPage } from '../pages/booking/CustomFormsPage';
import { ProjectsPage } from '../pages/project/ProjectsPage';

function HomeRedirect() {
  const { isAuthenticated } = useAuth();
  return (
    <Navigate to={isAuthenticated ? '/app/dashboard' : '/login'} replace />
  );
}

function PublicOnly({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/app/dashboard" replace />;
  return <>{children}</>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route
        path="/login"
        element={
          <PublicOnly>
            <LoginPage />
          </PublicOnly>
        }
      />
      <Route
        path="/register"
        element={
          <PublicOnly>
            <RegisterPage />
          </PublicOnly>
        }
      />

      {/* Redeems a short-url reset code; reachable while signed out. */}
      <Route path="/reset-password/:code" element={<ResetPasswordPage />} />

      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="maintenance/users" element={<UsersPage />} />
        <Route path="maintenance/customers" element={<CustomersPage />} />
        <Route path="booking/bookings" element={<BookingsPage />} />
        <Route path="booking/services" element={<ServicesPage />} />
        <Route path="booking/categories" element={<ServiceCategoriesPage />} />
        <Route path="booking/custom-forms" element={<CustomFormsPage />} />
        <Route path="setting" element={<SettingPage />} />
        <Route path="appearance" element={<AppearancePage />} />
        <Route path="about-us" element={<AboutUsPage />} />
        <Route path="whatsapp" element={<WhatsAppPage />} />
        <Route
          path="platform/projects"
          element={
            <PlatformRoute>
              <ProjectsPage />
            </PlatformRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}


